import { Button, Text, Tooltip } from "@mantine/core"
import { useHover } from "@mantine/hooks"

import { ALL_OTHERS } from "@costory/shared/const"
import { OTHERS } from "@costory/shared/utils/explorer_data"

import useCmdClick from "@costory/front/components/common/CmdClick"
import { truncateLabel } from "@costory/front/utils/charts"

interface DrillDownCellProps {
  value: string
  maxLength?: number
  drillDownInto: (value: string, mode: "sameWindow" | "newTab") => void
}

export const DrillDownCell = ({
  value,
  maxLength = 35,
  drillDownInto,
}: DrillDownCellProps) => {
  const truncatedValue = truncateLabel(value, maxLength)
  const { hovered, ref } = useHover()
  const isModifierPressed = useCmdClick()
  const shouldHighlight = hovered && isModifierPressed

  return (
    <>
      {value === ALL_OTHERS || value === OTHERS ? (
        <Button
          p={0}
          display="flex"
          justify="flex-start"
          style={{ userSelect: "text", pointerEvents: "none" }}
          variant="transparent"
          c="unset"
        >
          {value}
        </Button>
      ) : (
        <Tooltip label={value} withArrow disabled={value.length <= maxLength}>
          <Button
            p={0}
            display="flex"
            justify="flex-start"
            style={{
              userSelect: "text",
              textDecorationLine: shouldHighlight ? "underline" : "none",
            }}
            onClick={(event) => {
              const mode = event.metaKey ? "newTab" : "sameWindow"
              drillDownInto(value, mode)
            }}
            variant="transparent"
            ref={ref}
          >
            <Text
              size="sm"
              fw={500}
              onCopy={(e) => {
                e.preventDefault()
                e.clipboardData.setData("text/plain", value)
              }}
            >
              {truncatedValue}
            </Text>
          </Button>
        </Tooltip>
      )}
    </>
  )
}
